import {BaseObject} from './BaseObject';
import {Contract} from './Contract';
import {User} from './User';

export class TransportRepeat extends BaseObject {
    id: number;
    title: string;
    fromTime: string = '10:00';
    toTime: string = '12:00';
    users: User[] = [];
    note: string;
    isCatering: boolean = false;
    isKitchen: boolean = false;
    isExternal: boolean = false;
    outsidePrague: boolean = false;
    isManipulation: boolean = false;
    address: string | null;
    addressLat: number;
    addressLon: number;
    rrule: string = '';
}




// WEBPACK FOOTER //
// /app/src/model/Entities/TransportRepeat.ts